<div class="bank-data-tab">

  <div class="alert alert-info" *ngIf="company.bank_data?.companies_count > 1">
    Ce compte bancaire est partagé par {{ company.bank_data.companies_count }} sociétés.
    Toute modification s'appliquera à l'ensemble d'entre elles.
  </div>

  <div *ngIf="company.bank_data; else noBankData">
    <div class="form-group row">
      <label class="col-sm-2 control-label">Nom</label>
      <div class="col-sm-10">
        <input class="form-control" name="bank_data_label"
               [readonly]="mode === 'normal' || !hasPermissions('Antoine:TaxationDataAdmin')"
               [(ngModel)]="company.bank_data.label">
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 control-label">Numéro de Compte</label>
      <div class="col-sm-10">
        <input class="form-control" name="bank_data_rib"
               [readonly]="mode === 'normal'"
               [(ngModel)]="company.bank_data.rib">
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 control-label">IBAN</label>
      <div class="col-sm-10">
        <input class="form-control" name="bank_data_iban"
               [readonly]="mode === 'normal' || !hasPermissions('Antoine:TaxationDataAdmin')"
               [(ngModel)]="company.bank_data.iban">
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 control-label">BIC</label>
      <div class="col-sm-10">
        <input class="form-control" name="bank_data_bic"
               [readonly]="mode === 'normal' || !hasPermissions('Antoine:TaxationDataAdmin')"
               [(ngModel)]="company.bank_data.bic">
      </div>
    </div>
  </div>

  <ng-template #noBankData>
    <p class="text-muted" *ngIf="mode === 'normal'">Aucune coordonnée bancaire associée à cette société.</p>
    <button class="btn btn-default" type="button" *ngIf="mode === 'normal' || !hasPermissions('Antoine:TaxationDataAdmin')" (click)="initBankData()">
      <i class="fas fa-plus"></i> Ajouter des coordonnées bancaires
    </button>
  </ng-template>
</div>
